module.exports = __webpack_public_path__ + "static/media/2_r_malbeert_80.99_78.8.9f25d4e5.png";